import React from 'react'
import styles from "./errorpage.module.css";
import { useNavigate } from 'react-router-dom';

const ErrorPage = () => {
    const navigate = useNavigate();
    return (


        <div className={styles.contactCol2}>
            <img src='/assets/error.png' />
            <h2>Oops! data not found</h2>
            <p>The data you are looking for might have been removed or
            temporarily unavailable.</p>
            <div className={styles.buttonGroup}>
                <button type="submit" className={styles.saveButton} onClick={() => navigate('/')}>
                    Back to Home
                </button>
            </div>
        </div>
    )
}

export default ErrorPage